import React, { useState, useMemo } from "react";
import { Modal, message } from "antd";
import { moveTopic } from "../../../services/polly/classificationService";

function flattenForMove(topics, excludeId, result = [], depth = 0) {
  for (const t of topics) {
    const isExcluded = t.id === excludeId;
    result.push({ id: t.id, name: t.name, depth, disabled: isExcluded });
    if (t.children && !isExcluded) {
      flattenForMove(t.children, excludeId, result, depth + 1);
    }
  }
  return result;
}

export default function MoveTopicModal({ visible, topic, allTopics, onCancel, onSuccess }) {
  const [selectedParentId, setSelectedParentId] = useState(undefined);
  const [saving, setSaving] = useState(false);

  const options = useMemo(() => {
    if (!topic) return [];
    return [
      { id: null, name: "Top level", depth: 0, disabled: false },
      ...flattenForMove(allTopics || [], topic.id),
    ];
  }, [topic, allTopics]);

  const handleMove = async () => {
    if (selectedParentId === undefined) return;
    setSaving(true);
    try {
      await moveTopic(topic.id, selectedParentId);
      message.success("Topic moved");
      setSelectedParentId(undefined);
      onSuccess && onSuccess();
    } catch (err) {
      const msg = err?.response?.data?.message || "Move failed";
      message.error(msg);
    }
    setSaving(false);
  };

  return (
    <Modal
      title="Move topic"
      open={visible}
      onCancel={() => { setSelectedParentId(undefined); onCancel(); }}
      onOk={handleMove}
      okText="Move topic"
      confirmLoading={saving}
      okButtonProps={{ disabled: selectedParentId === undefined }}
    >
      <p style={{ fontSize: 12, color: '#555', marginBottom: 12 }}>
        Select a new parent for <strong>{topic?.name}</strong>. All child topics and conversations move with it.
      </p>
      <div className="ca-move-tree">
        {options.map((opt) => (
          <div
            key={opt.id === null ? 'root' : opt.id}
            className={`ca-move-row${selectedParentId === opt.id ? ' selected' : ''}${opt.disabled ? ' disabled' : ''}`}
            style={{ paddingLeft: 8 + opt.depth * 16 }}
            onClick={() => !opt.disabled && setSelectedParentId(opt.id)}
          >
            {opt.id === null ? '\uD83D\uDCC1' : opt.depth === 0 ? '\uD83D\uDCC2' : '\u2014'} {opt.name}
            {opt.disabled && <span style={{ color: '#bbb', fontSize: 10, marginLeft: 4 }}>(current)</span>}
          </div>
        ))}
      </div>
      {selectedParentId !== undefined && (
        <p style={{ fontSize: 11, color: '#888', marginTop: 8 }}>
          Will move to: <strong>{options.find((o) => o.id === selectedParentId)?.name || 'Top level'}</strong>
        </p>
      )}
    </Modal>
  );
}
